<template>
  <div style="height: 100%;">
    <!--空调温湿度-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
          style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>空调温湿度</span>
    </div>
    <div class="overflow" style="overflow: auto;height: 80%;" v-if="data.length > 0">
      <el-row :key="item.id" style="padding-top: 10px;margin-top: 20px;font-size: .9rem;" v-for="item in data">
        <el-col :span="8" style="text-align: center;padding: 5px 10px 0 9%;">
          <img src="../../../assets/images/comprehensive/空调.png">
          <div style="font-weight: bold;margin-top: 5px;">{{ item.name }}</div>
        </el-col>
        <el-col :span="11">
        <span :key="history.id" v-for="history in item.deviceMeasuringPointHistoryList">
          <div style="width: 130%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 3px;"
               v-if="history.pointCode === 'tcv'">
            <img src="../../../assets/images/comprehensive/当前温度.png" style="margin-right: 20px;margin-top: -4px;">
            <span>当前温度：<span id="currentTemp"
                             style="font-size: 1rem;color: rgba(41, 159, 251, 1);font-weight: bold">{{
                history.pointValueName
              }}</span></span>
          </div>
          <div style="width: 130%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 3px;margin-top: 8px;"
               v-if="history.pointCode === 'oac_sett' || history.pointCode === 'ste' ">
            <img src="../../../assets/images/comprehensive/设定温度.png" style="margin-right: 15px;">
            <span>设定温度：<span id="settingTemp"
                             style="font-size: 1rem;color: rgba(41, 159, 251, 1);font-weight: bold">{{
                history.pointValueName
              }}</span></span>
          </div>
          <div style="width: 130%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 3px;margin-top: 8px;"
               v-if="history.pointCode === 'hv'">
            <img src="../../../assets/images/comprehensive/当前湿度.png" style="margin-right: 20px;margin-top: -4px;">
            <span>当前湿度：<span id="currentHumi"
                             style="font-size: 1rem;color: #07E6F8;font-weight: bold">{{
                history.pointValueName
              }}</span></span>
          </div>
          <div style="width: 130%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 3px;margin-top: 8px;"
               v-if="history.pointCode === 'sh'">
          <img src="../../../assets/images/comprehensive/设定湿度.png" style="margin-right: 15px;">
          <span>设定湿度：<span id="settingHumi"
                           style="font-size: 1rem;color: #07E6F8;font-weight: bold">{{ history.pointValueName }}</span></span>
        </div>
        </span>
        </el-col>
      </el-row>
    </div>
    <no-data style="margin-top: 15%;" v-else></no-data>
  </div>
</template>

<script>

import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";

export default {
  name: "AirConditioner",
  components: {NoData},
  inject: ['overflow'],
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  mounted() {
    this.overflow()
    this.getData();
  },
  watch: {
    spaceId() {
      this.data = []
      this.getData();
    },
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getAirConditioner:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getAirConditioner')
  },
  data() {
    return {
      data: [],
      typeList: ["PM_OAC", "PM_AC"],//普通空调,精密空调
      pointCodes: ["tcv", "oac_sett", "ste", "sh", "hv"],//温度当前值,设置温度, 设定温度,设定湿度,湿度当前值
    }
  },
  methods: {
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.data = []
            res.data.forEach(item => {
              item.deviceInfoList.forEach(deviceInfo => {
                this.data.push(deviceInfo);
              })
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
